import type {DirectoryData} from '~/types/DirectoryData'

export const hasDirectoryUnseenCapture = (directory: DirectoryData) => {
    return directory.studentCaptures.some(captureData => {
        return !captureData.isSeen
    })
}